import React from "react";
import LetterProcessing from "../Settings/LetterProcessing";

const LetterProcessingPage = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <LetterProcessing />
      </div>
    </div>
  );
};

export default LetterProcessingPage;
